import { React, useContext } from "react";
import ThemeContext from "../context/ThemeContext";
import "./About.css";

const About = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <>
      <div className="about_container">
        <div className="profile_image">
          <img src="/assets/images/Profile.jpg" alt="" />
        </div>
        <div className={`about_content ${theme}`}>
          <h2>About</h2>

          <p>
            {`Hello! I’m Vahid, a motion designer, animator, and compositor with over seven years of experience creating visual content across 2D and 3D.
Over the years, I’ve worked with studios, brands, and creative teams in Iran and internationally, contributing to a wide range of animation and motion projects. My work often focuses on animation, compositing, and bringing different visual elements together into a polished final piece.
My background is actually in Electrical Engineering, and that technical foundation has shaped the way I approach my work. I enjoy understanding how things work, solving visual problems, and finding the right balance between technique and creativity.
As my experience has grown, I’ve become increasingly interested in the artistic side of animation—not just how something moves, but how composition, storytelling, rhythm, and visual direction can make an idea more meaningful.
Alongside my professional work, I also enjoy learning, teaching, and experimenting with new tools and techniques. I’m always looking for new ways to grow creatively and bring stronger ideas to life.`}
          </p>
          <h2>contact :</h2>
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=vahidhanid96@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            vahidhanid96@gmail.com
          </a>
        </div>
      </div>
      <hr />
      <div className="image_bottom">
        <a href="https://www.instagram.com/vahidhanid0014?igsh=Ym5qeXo1Mnd0NXFj" target="_blank" rel="noopener noreferrer">
          <img src="/assets/images/about.png" alt="" />
        </a>
      </div>
    </>
  );
};

export default About;
